(ns manage.ad-variant.creation.feed.mapping.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/InputAdornment$default" :as InputAdornment]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/ListSubheader$default" :as ListSubheader]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Popper$default" :as Popper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            ["src/svg/artwork/warning.svg$default" :as Warning]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            ["src/svg/organisations/other/meta.svg$default" :as MetaIcon]
            ["src/svg/organisations/other/tiktok.svg$default" :as TiktokIcon]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.form :as form]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [manage.ad-variant.creation.content.hooks :as ch]
            [manage.ad-variant.creation.feed.mapping.hooks :as h]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-icon-by-type
  [type]
  (case type
    "identifier" "key"
    "collection" "data_array"
    "text" "title"
    "image" "image_outlined"
    "click" "link_url"
    "video" "video_camera_back"
    "template-dimensions" "backup_table_outlined"
    "click-through" "ads_click"
    "youtube-description" "title"
    "clear-cast-id" "schedule_outlined"
    "content" "title"
    "pass-through-url" "video_camera_back"
    "pass-through-thumbnail" "image_outlined"
    "clear"))

(defui text-field
  [{:keys [name parent-collection type tooltip tooltip-read-more-url tooltip-read-more-cta]}]
  ($ TextField
     {:InputProps #js {:startAdornment ($ InputAdornment
                                          {:position "start"}
                                          ($ Stack {:direction "row" :gap 1}
                                             (cond
                                               (str/starts-with? type "meta-") ($ MetaIcon)
                                               (str/starts-with? type "tiktok-") ($ TiktokIcon)

                                               :else ($ Icon (get-icon-by-type type)))
                                             (when parent-collection
                                               parent-collection)))
                       :endAdornment (when tooltip
                                       ($ InputAdornment
                                          {:position "end"}
                                          ($ Tooltip
                                             {:title ($ Typography tooltip
                                                        (when (and tooltip-read-more-url tooltip-read-more-cta)
                                                          ($ Link {:href tooltip-read-more-url
                                                                   :target "_blank"
                                                                   :sx #js {:ml 1
                                                                            :color "inherit"
                                                                            :textDecorationColor "inherit"}}
                                                             tooltip-read-more-cta)))
                                              :placement "top"}
                                             ($ Icon "info_outlined"))))}
      :size "small"
      :value name
      :disabled true
      :sx #js {:width 280
               "& .MuiInputBase-input.Mui-disabled" #js {:WebkitTextFillColor "#082040"}}}))

(defui select
  [{:keys [item control on-submit]}]
  (let [options (h/use-field-options)]
    ($ form/autocomplete-field
       {:name (str (:name item) ".value")
        :control control
        :field-props (fn [props]
                       {:options options
                        :data-testid (str "column-name-select-" (:name item))
                        :on-change (fn [value]
                                     ((get-in props [:field :onChange]) (->js value))
                                     (on-submit))
                        :placeholder "Select column name"
                        :name (str (:name item) ".value")
                        :groupBy (fn [option] (-> option ->clj :used (if "used" "unused")))
                        :render-option (fn [^js props option ^js _option-state _owner-state]
                                         (let [mapped? (-> option ->clj :used)
                                               color (if mapped? "grey.20" "text.primary")]
                                           ($ :li props
                                              ($ Typography
                                                 {:sx #js {:color color}}
                                                 (.-label option)))))
                        :renderGroup (fn [^js params]
                                       ($ Box
                                          {:component "li"
                                           :className "group"
                                           :key (.-key params)
                                           :sx #js {:borderBottom 1
                                                    :borderColor "grey.60"
                                                    "&:last-child" #js {:borderBottom 0}}}
                                          ($ ListSubheader
                                             {:component "div"
                                              :sx #js {:fontSize "body1.fontSize"
                                                       :textTransform "uppercase"
                                                       :height 40
                                                       :top -10}}
                                             (if (= "used" (.-group params)) "mapped" "unmapped"))
                                          ($ Box
                                             {:component "ul"
                                              :sx #js {:p 0}}
                                             (.-children params))))
                        :clearable? true
                        :sx #js {:width 280}})})))

(defui mapping-item
  [{:keys [item] :as opts}]
  (let [{:keys [value valid?]} item]
    ($ Stack
       {:direction "row"
        :alignItems "center"
        :gap 3}
       ($ text-field item)
       ($ Icon "arrow_forward")
       ($ select opts)
       (if value
         (if valid?
           ($ Icon {:sx #js {:color "green"}} "check")
           ($ Icon {:color "warning"} "warning"))
         ($ Stack {:width 20})))))

(defui sub-placeholder-select
  [{:keys [placeholder parent-name parent-intent control on-submit]}]
  (let [{:keys [setValue unregister]} (form/use-form-context)
        product-store-options (h/use-collection-product-fields parent-name parent-intent)
        feed-column-options (h/use-field-options)
        feed-mapping-enabled? (use-flag :product-placeholder-feed-mapping)
        field-name (str parent-name ".child-mapping." (:name placeholder) ".value")
        type-field-name (str parent-name ".child-mapping." (:name placeholder) ".type")
        source-column-field-name (str parent-name ".child-mapping." (:name placeholder) ".source-column")
        form-type (keyword (rhf/useWatch #js {:control control :name type-field-name}))
        form-value (rhf/useWatch #js {:control control :name field-name})
        form-source-column (rhf/useWatch #js {:control control :name source-column-field-name})
        has-product-field-selected? (and (some? form-value)
                                         (some #(= (% :value) form-value) product-store-options))
        has-feed-override? (and (= form-type :feed) (some? form-source-column))
        can-show-feed-options? (or has-product-field-selected? has-feed-override?)
        current-options (if (= form-type :feed)
                          (if can-show-feed-options? feed-column-options [])
                          product-store-options)
        feed-tab-disabled-message "First map a product field"]
    ($ Box
       ($ form/autocomplete-field
          {:name (if (= form-type :feed) source-column-field-name field-name)
           :control control
           :text-field-props {:InputProps
                              {:startAdornment
                               ($ InputAdornment
                                  {:position "start"
                                   :sx #js {:ml 1 :mr 0}}
                                  ($ Typography {:component "span"}
                                     (let [value-str
                                           (if (= form-type :feed)
                                             form-source-column
                                             form-value)]
                                       (cond
                                         (empty? value-str) ""
                                         (= form-type :feed) "Feed"
                                         (= form-type :product) "Products"))))}}
           :field-props (fn [props]
                          {:options current-options
                           :data-testid (str "sub-placeholder-select-" field-name)
                           :value (if (= form-type :feed) form-source-column form-value)
                           :on-change (fn [value]
                                        (if (and (nil? value) (= form-type :feed))
                                          (do
                                            (setValue type-field-name "product")
                                            (unregister source-column-field-name))
                                          ((get-in props [:field :onChange]) (->js value)))
                                        (on-submit))
                           :placeholder (let [has-value-for-selected-tab
                                              (if (= form-type :feed)
                                                (some? form-source-column)
                                                (some? form-value))]
                                          (cond
                                            has-value-for-selected-tab ""
                                            (= form-type :feed) "Select feed column"
                                            :else "Select product field"))
                           :name field-name
                           :groupBy (fn [option] (-> option ->clj :used (if "used" "unused")))
                           :render-option (fn [^js props option ^js _option-state _owner-state]
                                            (let [mapped? (-> option ->clj :used)
                                                  color (if mapped? "grey.20" "text.primary")]
                                              ($ :li props
                                                 ($ Typography
                                                    {:sx #js {:color color}}
                                                    (.-label option)))))
                           :renderGroup (fn [^js params]
                                          ($ Box
                                             {:component "li"
                                              :className "group"
                                              :key (.-key params)
                                              :sx #js {:borderBottom 1
                                                       :borderColor "grey.60"
                                                       "&:last-child" #js {:borderBottom 0}}}
                                             ($ ListSubheader
                                                {:component "div"
                                                 :sx #js {:fontSize "body1.fontSize"
                                                          :textTransform "uppercase"
                                                          :height 40
                                                          :top -10}}
                                                (if (= "used" (.-group params)) "mapped" "unmapped"))
                                             ($ Box
                                                {:component "ul"
                                                 :sx #js {:p 0}}
                                                (.-children params))))
                           :clearable? true
                           :sx #js {:width 280}
                           :PopperComponent (fn [^js props]
                                              ($ Popper (->js (assoc (->clj props)
                                                                     :placement "bottom-start"))
                                                 ($ Paper {:elevation 2
                                                           :sx #js {:mt 1}}
                                                    ($ Stack {:gap 1 :sx #js {:p 1}}
                                                       ($ rhf/Controller
                                                          {:name type-field-name
                                                           :control control
                                                           :render (fn [^js props]
                                                                     (let [^js field (.-field props)
                                                                           field-value (.-value field)
                                                                           toggle-value (if (= (keyword field-value) :feed) "feed" "product")]
                                                                       ($ Box {:onMouseDown (fn [e] (.preventDefault e))
                                                                               :onClick (fn [e] (.stopPropagation e))}
                                                                          ($ ToggleButtonGroup
                                                                             {:value toggle-value
                                                                              :exclusive true
                                                                              :onChange (fn [_event new-value]
                                                                                          (when new-value
                                                                                            (if (and (= new-value "feed")
                                                                                                     (not can-show-feed-options?))
                                                                                              nil
                                                                                              (.call (.-onChange field) nil new-value))))
                                                                              :size "small"
                                                                              :fullWidth true
                                                                              :sx #js {:mb 1}}
                                                                             ($ ToggleButton
                                                                                {:value "product"
                                                                                 :sx #js {:textTransform "none"}}
                                                                                "Product Store")
                                                                             (when feed-mapping-enabled?
                                                                               ($ Tooltip
                                                                                  {:title (if can-show-feed-options?
                                                                                            ""
                                                                                            feed-tab-disabled-message)
                                                                                   :disableHoverListener can-show-feed-options?}
                                                                                  ($ ToggleButton
                                                                                     {:value "feed"
                                                                                      :disabled (not can-show-feed-options?)
                                                                                      :sx #js {:textTransform "none"}}
                                                                                     "Feed")))))))})
                                                       ($ Box
                                                          {:sx #js {:px 2
                                                                    :pt 2
                                                                    :pb 1
                                                                    :display "flex"
                                                                    :alignItems "center"
                                                                    :gap 0.5}}
                                                          ($ Typography
                                                             {:variant "body1"
                                                              :sx #js {:fontWeight 600
                                                                       :color "text.secondary"}}
                                                             "Source")
                                                          ($ Tooltip
                                                             {:title (str "Use a value directly from a product field"
                                                                          (when feed-mapping-enabled?
                                                                            " or a content column from your feed"))
                                                              :placement "top"}
                                                             ($ Icon
                                                                {:sx #js {:fontSize 18
                                                                          :color "text.secondary"}}
                                                                "info_outlined")))
                                                       ($ Box (.-children props))))))})}))))

(defui sub-placeholder-mapping-item
  [{:keys [placeholder parent-name parent-intent control on-submit]}]
  ($ Stack
     {:direction "row"
      :alignItems "center"
      :gap 3}
     ($ text-field placeholder)
     ($ Icon "arrow_forward")
     ($ sub-placeholder-select {:placeholder placeholder
                                :parent-name parent-name
                                :parent-intent parent-intent
                                :control control
                                :on-submit on-submit})))

(defui mapping-collection
  [{:keys [item control on-submit] :as opts}]
  (let [{:keys [placeholders intent]} item
        placeholder-items (map (fn [[placeholder-key placeholder-config]]
                                 {:name (name placeholder-key)
                                  :type (:type placeholder-config)
                                  :parent-collection (:name item)
                                  :placeholder-key placeholder-key})
                               placeholders)]
    ($ Stack {:gap 2}
       ($ mapping-item opts)
       ($ Stack
          {:gap 1}
          (for [placeholder-item placeholder-items]
            ($ sub-placeholder-mapping-item
               {:key (:name placeholder-item)
                :item item
                :placeholder placeholder-item
                :parent-name (:name item)
                :parent-intent intent
                :control control
                :on-submit on-submit}))))))

(defui schedule-mapping [{:keys [control on-submit]}]
  (let [date-format-tooltip "Format: YYYY-MM-DDThh:mm:ss\nExample: 2024-01-15T14:30:00"
        timezone-tooltip "Example: America/New_York, Europe/London, Asia/Tokyo"
        schedule-fields [{:name "Timezone" :type "text" :tooltip timezone-tooltip}
                         {:name "Start date" :type "text" :tooltip date-format-tooltip}
                         {:name "End date" :type "text" :tooltip date-format-tooltip}]]
    ($ Stack {:gap 1
              :sx #js {:alignSelf "flex-start"}}
       (for [field schedule-fields]
         ($ mapping-item {:key (:name field)
                          :item field
                          :control control
                          :on-submit on-submit})))))

(defui mapping-form [{:keys [mapping-form-controls]}]
  (let [{:keys [on-submit* dimension-mapping-enabled?]} mapping-form-controls
        {:keys [control]} (form/use-form-context)
        template-items (h/use-suspense-template-items {:dimension-mapping-enabled? dimension-mapping-enabled?})
        ad-variant-scheduling-enabled? (use-flag :ad-variant-scheduling)]
    ($ :form {:onSubmit on-submit*}
       ($ Stack {:alignItems "center" :gap 1}
          (for [item (remove #(= "collection" (:type %)) template-items)]
            ($ mapping-item {:key item
                             :item item
                             :control control
                             :on-submit on-submit*}))
          (for [item (filter #(= "collection" (:type %)) template-items)]
            ($ :<> {:key (:name item)}
               ($ Divider {:sx #js {:width "100%"
                                    :my 2}})
               ($ mapping-collection {:item item
                                      :control control
                                      :on-submit on-submit*})))
          (when ad-variant-scheduling-enabled?
            ($ :<>
               ($ Divider {:sx #js {:width "100%"
                                    :my 2}})
               ($ Typography {:sx #js {:mb 1
                                       :alignSelf "flex-start"}}
                  "Schedule")
               ($ schedule-mapping {:control control
                                    :on-submit on-submit*})))))))

(def feed-error-boundary
  (uix.core/create-error-boundary
   {:derive-error-state (fn [error] {:error error})}
   (fn [[state _set-state!] {:keys [children]}]
     (let [{{:keys [message] :as error} :error} (->clj (get-in state [:error :data]))]
       (cond
         (= "redirected-to-sign-in-page-fetching" (get-in error [:details :reason]))
         ($ empty-state-view
            {:title "Feed is no longer accessible"
             :description "Please make the external feed link accessible and try again."
             :artwork Warning})

         (seq message)
         ($ empty-state-view
            {:title "Invalid feed"
             :description message
             :artwork Warning})

         :else children)))))

(defui mapping-view
  [{:keys [feed mapping-form-controls]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        feed-id (:id feed)
        can-safely-trigger-feed-import? (ch/use-can-safely-trigger-feed-import? {:advertiser-id advertiser-id :feed-id (:id feed)})
        has-inline-content-edits? (not can-safely-trigger-feed-import?)]
    (when feed-id
      ($ Stack
         {:alignItems "center"
          :flex 1
          :sx #js {:overflow "auto"
                   :pb 2}}
         ($ Stack {:gap 2}
            (when has-inline-content-edits?
              ($ Alert
                 {:severity "warning"
                  :sx #js {:width "628px"}
                  :icon ($ AlertIcon)}
                 "Updating your placeholder mappings will discard all your inline content changes."))
            ($ Typography
               {:variant "normal"}
               "Select a content column for each template placeholder")
            ($ mapping-form {:mapping-form-controls mapping-form-controls}))))))
